export default "__VITE_ASSET__C3Cx9oVx__"